/**
 * in this module there are all the functions needed to create the print view
 */

/**
 * import modules
 */
import {Image as ImageLayer} from 'ol/layer'
import ImageWMS from 'ol/source/ImageWMS'
import Cookies from './cookies'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Icon from 'ol/style/Icon'
import {Fill, Stroke, Circle, Style} from 'ol/style'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import WMTSCapabilities from 'ol/format/WMTSCapabilities'
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS'
import Projection from 'ol/proj/Projection'
import functions from './functions'
import marker from './marker'
import drawing from './drawing'
import twmap from './map'
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction'
import ScaleLine from 'ol/control/ScaleLine'
import {defaults as defaultControls} from 'ol/control'
/**
 * global var to reuse in the module
 */
const PMarksource = new VectorSource()
const PDrawsource = new VectorSource()

let printmap
var printfeatlayer = new Array()
let printmarkLayer
let printdrawLayer
let map
var pageconfig = JSON.parse($('#pageconfig').val())
let targetDiv = ''
let targetLeg = ''
const tenant = $('#tenant').val()
let layerClass = 'baselayer'
  /**
   * get the resolutions from the scales
   */
  const resolutions = []
/**
 * initialize the print tool
 */

const initPrint = (getMap) => {

  $('.print_template').on('click', function () {

    /**
     * change to the default value and hide the div
     */
     $('.print_template').removeClass('print_click')
     $(this).addClass('print_click')
    $('#printMod').modal('show')
  })
  /**
   * initialize the fixed settings
   * get the value of the select item
   * attache the source of the iframe
   * open the modal
   */
    /**
     * create the map view
     * set the modal size after 100 ms
     */
    map = getMap


  // temp scale array
  const scaleArray = []
  // scales array from fixed.json
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  // extent of the visible map
  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]
  let minZoom = pageconfig.minzoom
  var CookieSettings = Cookies.getUserPrefs()
  CookieSettings = CookieSettings == null ? null : CookieSettings.split(',')


    /**
     * PROJECTION
     */

    const projection = new Projection({
      code: 'EPSG:27700',
      getPointResolution: (r) => {
        return r
      },
      units: 'm'
    })

    for (let i in pageconfig.layers) {
      // feature layer
      if (pageconfig.layers[i].layers === 'parkmap') {
        let dDTo = $('#activedate').val().split('/').reverse().join('-')
        printfeatlayer.push(new ImageLayer({
          name: 'parkmap',
          extent: ext,
          source: new ImageWMS({
            url:  pageconfig.layers[i].wmsfeat,
            params: {'LAYERS': functions.getLayerList('parkmap'),
            MYORDERS: $('#featclick').val(),
            DTO: dDTo
            },
            ratio: 1,
            serverType: 'mapserver',
          })
        }))
      }
      if (pageconfig.layers[i].layers === 'accsmap') {


        let pdq = 'pdq0'
        if (pageconfig.pdq) {
          pdq = $('.pdq_on').attr('data-value')
        }
        let severity = 'none'
        if ($('#rtcfeatclick').val() !== '') {
          severity = $('#rtcfeatclick').val()
        }

        printfeatlayer.push(new ImageLayer({
          name: 'accsmap',
          extent: ext,
          source: new ImageWMS({
            url:  pageconfig.layers[i].wmsfeat,
            params: {
              'LAYERS': functions.getLayerList('accsmap'),
              SEVERITY: severity,
              ACCFROM: $('#fromdate').val().split('/').reverse().join('-'),
              PDQ: pdq,
              ACCTO: $('#todate').val().split('/').reverse().join('-'),
              PFILT: ''
            },
            ratio: 1,
            serverType: 'mapserver',
          })
        }))

      } else if (pageconfig.layers[i].layers === 'invmap') {

        printfeatlayer.push(new ImageLayer({
          name: 'invmap',
          extent: ext,
          source: new ImageWMS({
            url:  pageconfig.layers[i].wmsfeat,
            params: {
              'LAYERS': functions.getLayerList('invmap'),
              MYORDERS: $('#invfeatclick').val()
            },
            ratio: 1,
            serverType: 'mapserver',
          })
        }))
    } else if (pageconfig.layers[i].layers === 'psa') {

        printfeatlayer.push(new ImageLayer({
          name: 'psa',
          extent: ext,
          source: new ImageWMS({
            url:  pageconfig.layers[i].wmsfeat,
            params: {
              'LAYERS': functions.getLayerList('psa'),
              MYORDERS: $('#frapsafeatclick').val()
            },
            ratio: 1,
            serverType: 'mapserver',
          })
        }))
    } else if (pageconfig.layers[i].layers === 'fra') {
        const today = new Date()
        let sToday = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`

        printfeatlayer.push(new ImageLayer({
          name: 'fra',
          extent: ext,
          source: new ImageWMS({
            url:  pageconfig.layers[i].wmsfeat,
            params: {
              'LAYERS': functions.getLayerList('fra'),
              MYORDERS: $('#frapsafeatclick').val(),
              DTO: sToday,
            },
            ratio: 1,
            serverType: 'mapserver',
          })
        }))
      } // feature layer
    } //each page

    // Buchanan map cache
    var printcachelayer

      /**
   * mapcache layer
   * urls below are for testing mapcahce
   */
    let ovUrl = pageconfig.ovmap
    var ovlayerToUse = (CookieSettings == null ||  CookieSettings[3] == 'Zoomstack:undefined') ? pageconfig.ovlayer : CookieSettings[3]

    let capXml = functions.getCacheCapabilities()

    if (ovlayerToUse.indexOf('mastermap:mm') !== -1) {
        capXml = functions.getMMCacheCapabilities()
    }

    if (capXml === 'error') {
        // failover
        ovlayerToUse = 'miniscale'
        ovUrl = functions.getFailoverUrl()
    } else {
        // WMTS OK so no need for url
        ovUrl = ''
    }

    if (tenant == 'iom') {
      //iom uses mastermap as its cach/ov layer so get capabilities from there
      capXml = functions.getMMCacheCapabilities()
      layerClass = twmap.getIomLayerCSS(ovlayerToUse)
      ovlayerToUse = 'mastermap:mm-IoM_Overview'
    }

    if (ovlayerToUse.indexOf('Zoomstack:Zoomstack') === -1 && ovlayerToUse.indexOf('mastermap:mm') === -1) {
    //  url: 'https://6fc6cff.online-server.cloud/mapcache/?',
    //  url: 'https://www.buchananmapping.co.uk/mapcache/?',
    //   url: 'https://d0bfa2f.online-server.cloud/mapcache/?',
    printcachelayer = new TileLayer({
        // this extent limit the visible map
        extent: ext,
        minResolution: resolutions[minZoom],
        // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
        preload: Infinity,
        source: new TileWMS({
          url: ovUrl,
          params: {
            'LAYERS': ovlayerToUse,
            'TILED': true
          },
          ratio: 1,
          projection: 'EPSG:27700',
          tileGrid: new TileGrid({
            resolutions: resolutions,
            extent: ext,
            tileSize: [256, 256]
          })
        // resolutions doesn't work in the layer, has to stay in the view
        })
      })
    }
    else {
      var parser = new WMTSCapabilities()
      var result = parser.read(capXml)
      var options = optionsFromCapabilities(result, {
        layer: ovlayerToUse,
        matrixSet: 'BC27700'
      })

      var source = new WMTS(options)
      printcachelayer = new TileLayer({className: layerClass, extent: ext, source: source,minResolution: resolutions[3]})
    }

    /**
     * copyright  and mm layer
     */
    var printcopylayer
    var printmaplayer

/**
 * mastermap and copyright layer
 */
let mmUrl = pageconfig.ovmap
var mapLayerToUse = (CookieSettings == null ||  CookieSettings[3] == 'Zoomstack:undefined') ? pageconfig.wmslayer : CookieSettings[3]
if (mapLayerToUse.indexOf("Zoomstack:Zoomstack") !== -1) {
  mapLayerToUse = tenant === 'iom' ? 'mastermap:mm-IoM' : twmap.getMMLayer(mapLayerToUse);
}
let mmcapXml = functions.getMMCacheCapabilities()
if (mmcapXml === 'error') {
    // failover
    mapLayerToUse = 'miniscale'
    mmUrl = functions.getFailoverUrl()
  } else {
    // WMTS OK so no need for url
    mmUrl = ''
  }

if (mapLayerToUse.indexOf('mastermap:mm') === -1) {
   /**
   * copyright layer
   */

   printcopylayer = new TileLayer({
    className: 'baselayer',
    id: 'copylayer',
    // this extent limit the visible map
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: 'https://www.buchananmapping.co.uk/cgi-bin/wms_bccopy?&amp;service=WMS',
      params: {
        'LAYERS': 'copyright',
        'TILED': true
      },
      ratio: 1,
      gutter: 40,
      projection: projection,
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [280, 280]
      })
    // resolutions doesn't work in the layer, has to stay in the view
    })
  })

  printmaplayer = new TileLayer({
    className: layerClass, 
    id: 'maplayer',
    // this extent limit the visible map
    extent: ext,
    maxResolution: resolutions[minZoom-1],
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: mmUrl,
      params: {
        // the layers is a random layer in the map that we need to call in order to load the map
        'LAYERS': mapLayerToUse,
        'TILED': true
      },
      ratio: 1,
      projection: projection,
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })
} else {

    var parser = new WMTSCapabilities()
    var mmresult = parser.read(mmcapXml)
    var mmoptions = optionsFromCapabilities(mmresult, {
      layer: mapLayerToUse,
      matrixSet: 'BC27700'
    })
    var copyOptions = optionsFromCapabilities(mmresult, {
      layer: 'mastermap:bc-watermark',
      matrixSet: 'BC27700'
    })
    var mmsource = new WMTS(mmoptions)
    var copysource = new WMTS(copyOptions)

    printmaplayer = new TileLayer({className: layerClass,  id: 'maplayer', extent: ext, source: mmsource, resolutions: resolutions, maxResolution: resolutions[minZoom-1],preload: Infinity})
    printcopylayer = new TileLayer({className: 'baselayer', id: 'copylayer', extent: ext, source: copysource, resolutions: resolutions, maxResolution: resolutions[minZoom-1], preload: Infinity})
}



    printmap = new Map({
      /**
       * remove the interactions
       * extend the controls
       * get the layers from the main map
       * get the view from the main map
       */

      interactions: defaultInteractions({
        altShiftDragRotate: false,
        shiftDragZoom: false,
        mouseWheelZoom: false,
        pinchZoom: false,
        doubleClickZoom: false
        // dragPan: false
      }),
      controls: defaultControls({
        attributionOptions: ({
          collapsible: false
        })
      }).extend([
        new DragRotateAndZoom({
          target: 'printmap'
        }),
        // add the actual scale in "m"
        new ScaleLine({
          units: 'metric',
          target: 'print_scale_line'
        })
      ]),
      layers: [printcachelayer, printmaplayer, printcopylayer],
      view: map.getView(),
      target: 'printmap'
    })

    for (let i = 0; i < printfeatlayer.length; i++) {
      printmap.addLayer(printfeatlayer[i])
      printfeatlayer[i].setZIndex(2 + parseInt(i))
      printfeatlayer[i].setVisible(true)
    }
    if (pageconfig.draw) {
     addPrintDrawMarkers()
    }
    /**
     * move end event handler
     */

    printmap.on('moveend', () => {
      drag()
      printmap.updateSize()
      map.updateSize()
      refreshLegend()
      if (pageconfig.draw) {
        addMarkers(marker.markerSource())
      }
    })

    /**
     * close event on the modal
     *  - remove the print template and append a new iframe
     * this is because the content is written permanently and when
     * you open the modal again the content will be duplicate
     */

    $('#printMod').on('hidden.bs.modal', function (e) {
      map.updateSize()
    })

  /**
   * show event on the modal
   *  update feature layers
   */

  $('#printMod').on('show.bs.modal', () => {
    print(map)

    if (pageconfig.draw) {
      addPrintDrawMarkerFeatures(marker.markerSource(),drawing.getSource())
      addMarkers(marker.markerSource())
      setTimeout(() => {
        setModalSize()
      }, 100)
    }
    for (let i = 0; i < printfeatlayer.length; i++) {
      if (printfeatlayer[i].get('name') === 'accsmap') {
        let pdq = 'pdq0'
        if (pageconfig.pdq) {
          pdq = $('.pdq_on').attr('data-value')
        }
        let severity = 'none'

        if ($('#rtcfeatclick').val() !== ' ') {
          severity = $('#rtcfeatclick').val()
        }
        printfeatlayer[i].getSource().getParams().SEVERITY = severity
        printfeatlayer[i].getSource().getParams().ACCFROM = $('#fromdate').val().split('/').reverse().join('-')
        printfeatlayer[i].getSource().getParams().PDQ = pdq
        printfeatlayer[i].getSource().getParams().ACCTO = $('#todate').val().split('/').reverse().join('-')
        printfeatlayer[i].getSource().getParams().PFILT = $('#pfilt').val()
      } else if (printfeatlayer[i].get('name') === 'parkmap') {
        let dDTo = $('#activedate').val().split('/').reverse().join('-')
        printfeatlayer[i].getSource().getParams().MYORDERS = $('#featclick').val()
        printfeatlayer[i].getSource().getParams().DTO = dDTo
      } else if (printfeatlayer[i].get('name') === 'invmap') {
        printfeatlayer[i].getSource().getParams().MYORDERS = $('#invfeatclick').val()
      }
      printfeatlayer[i].getSource().refresh()
    }
    refreshLegend()
    printmap.updateSize()
    map.updateSize()

  })


  /**
   * force to open the browser print dialog whne you click on the button
   */

  $('#printBtn').click(() => {
    window.print()
  })

  /**
   * end const initPrint = (getMap) => {
   */
}

/**
 * create the print view
 */

const print = (map) => {
  /**
   * populate the pdatetext text, the date of creation that is today
   * populate the dataFilter text, the data came from the datepicker in the main page
   */

  const today = new Date()
  let todayDate = today.getDate()
  let todayMonth = today.getMonth() + 1

  $('#pdatetext').html(`Date created: ${functions.leadZero(todayDate)}/${functions.leadZero(todayMonth)}/${today.getFullYear()}`)

  /** get template style */
  let templateLogo = $('.print_click').first().attr('data-logo')
  if (templateLogo !== '') {
    $('#logoimg').attr('src',templateLogo)
  }
  /** get template orientation */
  let templateOrient = $('.print_click').first().attr('value')

  if (templateOrient === 'portrait') {
    // portrait
    $('#printmap').removeClass('map_p map_l').addClass('map_p')
    $('#pllegwrapper').removeClass('pllegwrapper_p pllegwrapper_l').addClass('pllegwrapper_p')
    $('#twdiv').removeClass('twdiv_p twdiv_l').addClass('twdiv_p')
    $('#logocontainer').removeClass('logocontainer_p logocontainer_l').addClass('logocontainer_p')
    $('#logodiv').removeClass('logodiv_p logodiv_l').addClass('logodiv_p')
    $('#orderdisplay').removeClass('orderdisplay_p orderdisplay_l').addClass('orderdisplay_p')
    $('#datenotesdiv').removeClass('datenotesdiv_p datenotesdiv_l').addClass('datenotesdiv_p')
    $('#plmapcontrols').removeClass('plmapcontrols_p plmapcontrols_l').addClass('plmapcontrols_p')
    $('#plwrapper').removeClass('plwrapper_p plwrapper_l').addClass('plwrapper_p')
    $('#print_copytext').removeClass('copytext_p copytext_l').addClass('copytext_p')
  } else {
    // landscape
    $('#printmap').removeClass('map_p map_l').addClass('map_l')
    $('#pllegwrapper').removeClass('pllegwrapper_p pllegwrapper_l').addClass('pllegwrapper_l')
    $('#twdiv').removeClass('twdiv_p twdiv_l').addClass('twdiv_l')
    $('#logocontainer').removeClass('logocontainer_p logocontainer_l').addClass('logocontainer_l')
    $('#logodiv').removeClass('logodiv_p logodiv_l').addClass('logodiv_l')
    $('#orderdisplay').removeClass('orderdisplay_p orderdisplay_l').addClass('orderdisplay_l')
    $('#datenotesdiv').removeClass('datenotesdiv_p datenotesdiv_l').addClass('datenotesdiv_l')
    $('#plmapcontrols').removeClass('plmapcontrols_p plmapcontrols_l').addClass('plmapcontrols_l')
    $('#plwrapper').removeClass('plwrapper_p plwrapper_l').addClass('plwrapper_l')
    $('#print_copytext').removeClass('copytext_p copytext_l').addClass('copytext_l')
  }
  /**
   * populate the pdatetext text, the date of creation that is today
   * populate the dataFilter text, the data came from the datepicker in the main page
   */

  if (pageconfig.appname.type === 'parkmap') {
    $('.dataFilter').html(`Date displayed: ${$('#activedate').val()}`)
  }
  else if (pageconfig.appname.type === 'accsmap') {
    $('.dataFilter').html($('.amdisclaimer .accfiltsel').text().replace('Displaying ', ''))
  }
  else if (pageconfig.appname.type === 'invmap') {
    $('.dataFilter').html(`Parking Date displayed: ${$('#activedate').val()}`)
  }

  /**
   * update the map for the print
   */

 // printmap()
  printmap.setView(map.getView())

  /**
   * force the map t oupdate the size after 300ms
   * for some reason sometimes the map doesn't display even if is there
   */

  setTimeout(() => {
    printmap.updateSize()
  }, 300)

  /**
   * end const print = () =>
   */
}

/**
 * refresh the Legend when the map has finish to move
 */

const refreshLegend = () => {
/**
 * if the legend is already created remove it before to create the new one
 */

  $('.legendlist').empty()
  $('.legendlist').remove()

  /**
   * get the visibles restrictions form the BD and create the legend
   */
  ajaxVisibleLayers()

}

/**
 * get the ID of the visible restriction in the print view
 */

const ajaxVisibleLayers = () => {
  /**
   * get the map extents and extract coords
   */

  const bcoords = printmap.getView().calculateExtent(printmap.getSize())

  /**
   * send the request with 3 params
   *  - boundaries (bccords)
   *  - the layers to query (orderl, orderp, etc)
   *  - the date in US format
  */

  let jsonString = ''
  for (let i in pageconfig.layers) {
    if (pageconfig.layers[i].layers === 'parkmap') {
      jsonString += `{"type":"parkmap","bbox":"${bcoords}","layers":"${printfeatlayer[i].getSource().getParams().LAYERS}","date":"${$('#activedate').val().split('/').reverse().join('-')}"},`
    } else if (pageconfig.layers[i].layers === 'accsmap'){
      jsonString += `{"type":"accsmap","bbox":"${bcoords}","layers":"${printfeatlayer[i].getSource().getParams().LAYERS}"},`
    } else if (pageconfig.layers[i].layers === 'invmap') {
      jsonString += `{"type":"invmap","bbox":"${bcoords}","layers":"${printfeatlayer[i].getSource().getParams().LAYERS}"},`
    } else {
      jsonString += `{"type":"${pageconfig.layers[i].layers}","bbox":"${bcoords}", "layers":"${printfeatlayer[i].getSource().getParams().LAYERS}"},`
    }
  }


  //
  jsonString = jsonString.replace(/,(?=\s*$)/, '')
  jsonString = '{"printlayers":[' + jsonString + ']}'
  //console.log(jsonString)

  //jsonString = '{"printlayers":[{"type": "parkmap","bbox": "507933.4533240469,182093.70222484967,508068.6933240469,182261.84222484968", "layers": "ordersl,ordersp,mordersr,mordersl,minv,ordersr,mordersp", "date": "2021-03-11"}]}'
  //console.log(jsonString)
  /**
   * check if it's a parkamp accsmap or invmap tw
   * send the request in get method
   * send the tequest in post method if it's invmap
   */
   $('.loading').show()
    $.ajax({
      url: '/printlayers',
      type:"POST",
      data: {
        jdata: jsonString
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
      },
      success: function (data) {

        layerHandler(data)
      },
      complete: function () {
        $('.loading').hide()
      }})


  /**
   * end const ajaxVisibleLayers = (sQLayers) => {
   */
}

/**
 * display the visible features and create the legend
 * this function it's called inside ajaxVisibleLayers
 */

const layerHandler = (featIDs) => {
/**
 * set fullLegend to false
 */

  let fullLegend = false

  /**
   * set:
   *  - visGroup the same as $('#featclick') or $('#rtcfeatclick') or $('#Invfeatclick') that contains all the visible restrictions ID in the map
   * this is based on the type of TW
   */

  /**
   * set groupFromDb the same as the parameter that contains the visible restriction in the actual view
   */

  let groupFromDb = ''
  groupFromDb = JSON.parse(featIDs)

  /**
   * check the orientation of the print template and set the maxLegendItems var
   */

  let maxLegendItems
  if ($('.print_click').attr('data-orientation') === 'portrait') {
    maxLegendItems = 5
  }
  else {
    maxLegendItems = 10
  }

  /**
   * check if the restrictions to dipslay are more than the allows and:
   *  - dipslay/hide the second page
   *  - set the fullLegend var to true or false
   */
   let maxItem = 0
  if(groupFromDb.hasOwnProperty('parkmap')){
    maxItem += groupFromDb.parkmap.length
  }
  if(groupFromDb.hasOwnProperty('invmap')){
    maxItem += groupFromDb.invmap.length
  }
  if(groupFromDb.hasOwnProperty('accsmap')){
    maxItem += groupFromDb.accsmap.length
  }

    if (maxItem > maxLegendItems) {
      $('#pllegwrapper').css('display', 'block')
      $('#pagesplit').addClass('secpage')
      fullLegend = true
    }
    else {
      $('#pllegwrapper').css('display', 'none')
      $('#pagesplit').removeClass('secpage')
      fullLegend = false
    }


  /**
   * check the orientation of the print template and if the legend is full and set the maxLegendItems var
   */

  if (fullLegend && $('#tlprint').attr('data-orientation') === 'portrait') {
    maxLegendItems = 49
  }
  else if (fullLegend && $('#tlprint').attr('data-orientation') === 'landscape') {
    maxLegendItems = 32
  }

  /**
   * check if the legend is full and set the target for the legend
   */

  if (fullLegend) {
    targetDiv = 'orderdisplaycol1'
    targetLeg = 'legend_list1'
  }
  else {
    targetDiv = 'orderdisplay'
    targetLeg = 'legend_list'
  }

  /**
   * create and append the list to the target
   */
  /**
   * set the legend item count to 0
   */

  let legendItemCnt = 0

  /**
   * check if the parkmap legend it's visible
   * get the features for parkmap
   */
  let featurelist = []
  let featuretype = ''
  $('<ul>', {
    id: targetLeg
  }).addClass('legendlist').appendTo(`#${targetDiv}`)
  for (var key in groupFromDb) {
    // get features returned from bbox search and only select
    // those in the current selection
    featurelist = []
    if (groupFromDb.hasOwnProperty(key)) {
        featuretype = key
        let bboxfeat = groupFromDb[key]
        if (key == 'parkmap') {
            let pmfeat = $('#featclick').val().split(',').map(Number)
            featurelist = _.intersection(bboxfeat,pmfeat)
        } else if (featuretype == 'invmap') {
            let invfeat = $('#invfeatclick').val().split(',').map(Number)
            featurelist = _.intersection(bboxfeat,invfeat)
        } else if (featuretype == 'accsmap') {
            let accfeat = $('#rtcfeatclick').val().replace(/(^|[^\\])(\\\\)*\\$/,'"').replace(/'/g,'').split(',')
            bboxfeat = bboxfeat.join(',').replace(/"/g, "'").split(',')
            featurelist = _.intersection(bboxfeat,accfeat)
        }
        addPrintLegendItems(key,featurelist,legendItemCnt, maxLegendItems)
    }

  }

  /**
   * end const layerHandler = (featIDs) =>
   */
}

/**
 * Add legend items
 */

 const addPrintLegendItems = (featuretype, featurelist, legendItemCnt, maxLegendItems) => {
/*   console.log(featuretype)
  console.log(featurelist) */
  if (featurelist.length > 0) {

    for (var legfeat = 0;legfeat < featurelist.length;legfeat++) {
      /**
       * increment the legend item count plus 1
       * check if the legend is full or not
       * assign the correct target
       */
      legendItemCnt += 1

      if (legendItemCnt > maxLegendItems) {
        if (targetDiv === 'orderdisplaycol1') {
          targetDiv = 'orderdisplaycol2'
          targetLeg = 'legend_list2'
        }
        else {
          targetDiv = 'orderdisplaycol3'
          targetLeg = 'legend_list3'
        }

        legendItemCnt = 0
        $('<ul>', {
          id: targetLeg
        }).addClass('legendlist').appendTo(`#${targetDiv}`)
      }
      let legid = featuretype + "_legend_" + featurelist[legfeat]
      if (featuretype === 'accsmap') {
        // deepcode ignore GlobalReplacementRegex: <please specify a reason of ignoring this>
        legid = legid.replace(' ','_')
        if ($('#'+ legid).find('img').length > 0) {
          $('#' + targetLeg).append("<li id='printli" + featurelist[legfeat]  + "' class='leglist clearfix'><img class='" + $('#'+ legid +' img').attr('class') + "' src='" + $('#'+ legid +' img').attr('src') + "' style='float:right;" + $('#'+ legid +' img').attr('style') + "'><span style='display:block'>" +  $('#'+ legid +' label').text() + "</span></li>")
        } else {
          $('#' + targetLeg).append("<li id='printli" + featurelist[legfeat]  + "' class='leglist clearfix'><div class='legImg' style='" + $('#'+ legid +' .legImg').attr('style') + "'></div><span style='display:block'>" +  $('#'+ legid +' label').text() + "</span></li>")
        }
      } else {
        // invmap and parkmap
        $('#' + targetLeg).append("<li id='printli" + featurelist[legfeat]  + "' class='leglist clearfix'><img class='" + $('#'+ legid +' img').attr('class') + "' src='" + $('#'+ legid +' img').attr('src') + "' style='float:right;" + $('#'+ legid +' img').attr('style') + "'><span style='display:block'>" +  $('#'+ legid +' label').text() + "</span></li>")
      }

    }
    return legendItemCnt
  }
  /**
   * End of addPrintLegendItems
   */
 }
/**
 *
 * Create print markers
 */

const addPrintDrawMarkers = () => {

  const myColors = ['rgba(255,255,255,0.1)']
  const mySource = ['/img/symbols/marker1.png', '/img/symbols/marker2.png', '/img/symbols/marker3.png', '/img/symbols/marker4.png', '/img/symbols/marker5.png']

  /**
   * add the correct symbols and prevent duplicates
   */

  let iterator = 0

  const styleFn = (symbol) => {
    let retSytle

    /**
     * get the current style if is already setup
     */

    if (typeof (symbol.get('styledwithcolor')) !== 'undefined') {
      retSytle = new Style({
        image: new Icon({
          // opacity: 0.95,
          src: symbol.get('mysource'),
          color: symbol.get('styledwithcolor')
        })
      })
    }
    /**
     * else set the new style
     */

    else {
      symbol.set('styledwithcolor', myColors[iterator])
      symbol.set('mysource', mySource[iterator])

      retSytle = new Style({
        image: new Icon({
          src: mySource[iterator],
          color: myColors[iterator]
        })
      })
      /**
       * removing the last symbols prevent to add duplicates
       */

      mySource.shift()
    }
    return [retSytle]
  }

  /**
   * marker layer
   * set the z-index of the layer to 6 to be sure that is on top of all the others one
   */

  printmarkLayer = new VectorLayer({
    source: PMarksource,
    style: styleFn
  })

  printmarkLayer.setZIndex(6)
  /**
   * add the markLayer layer to the map
   */

  printmap.addLayer(printmarkLayer)

  /**
   * Add Drawing Layer
   */
  printdrawLayer = new VectorLayer({
    source: PDrawsource,
    style: new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: '#328cc1',
        width: 4
      }),
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#328cc1'
        })
      })
    })
  })

  printdrawLayer.setZIndex(6)

  /**
   * add the drawing layer to the map
   */

  printmap.addLayer(printdrawLayer)

}

const addPrintDrawMarkerFeatures = (Msource,Dsource) => {
  PDrawsource.clear(true)
  PMarksource.clear(true)
  PDrawsource.addFeatures(Dsource.getFeatures())
  PMarksource.addFeatures(Msource.getFeatures())
}

/**
 * add the marker popup on top of the map
 */
const addMarkers = (Msource) => {
  /**
   * check if there are some text areas in the drawing section
   */

  if ($('.textDiv')[0].children === 0) {
    return
  }

  /**
   * get the marker text from the drawing section
   * it's an HTML collection, array
   */

  let markerText = $('.textDiv')[0].children

  /**
   * remove all the markers popup if present so we can recreate them later
   */

  if ($('.marker').length > 0) {
    $('.marker').remove()
  }

  /**
   * set the initial position of the marker popup to 1
   * get the coordinates from the map
   */

  let markerInitialpos = 1
  let bcoords = printmap.getView().calculateExtent(printmap.getSize())

  /**
   * create the marker popup
   */

  for (let i = 0; i < markerText.length; i++) {
    /**
     * check if the marker is visible in the actual view and create the popup
     */

    if (Msource.getFeatures()[i].getGeometry().getCoordinates()[0] > bcoords[0] && Msource.getFeatures()[i].getGeometry().getCoordinates()[0] < bcoords[2] && Msource.getFeatures()[i].getGeometry().getCoordinates()[1] > bcoords[1] && Msource.getFeatures()[i].getGeometry().getCoordinates()[1] < bcoords[3]) {
    /**
     * get the text from each textarea in the markerText
     * add 60 px to the markerInitialpos
     */

      let text = markerText[i].value
      markerInitialpos += 60

      /**
       * create the popup div
       * append it to the map
       */

      $('<div>', {
        id: 'd' + i,
        style: `top:${markerInitialpos}px;`
      }).addClass('marker').appendTo($('#printmap'))

      /**
       * get the image from the drawing source
       * append it to the popup
       */

      $('<div>', {
        id: i,
        style: `background-image:url('${Msource.getFeatures()[i].getProperties().mysource}');`
      }).addClass('markerIcon').appendTo($(`#d${i}`))

      /**
       * add the text to the popup
       */

      $('<span>', {
        id: 's' + i,
        text: text
      }).appendTo($(`#d${i}`))

      /**
       * end if marker is in the visible map
       * end for loop
       * end const addMarkers = (Msource) =>
       */
    }
  }
}

/**
 * enable the drag on the marker popup
 */

const drag = () => {
/**
 * enable the drag on the marker popup
 */

  let dragging = false
  let iX
  let iY
  let movdiv

  $('#printmap').on('mousedown', '.marker', function (e) {
    dragging = true
    movdiv = $(this)
    iX = e.clientX - this.offsetLeft
    iY = e.clientY - this.offsetTop
    this.setCapture && this.setCapture()
    return false
  })

  $('#printmap').on('mousemove', function (e) {
    if (dragging) {
      let x = e || window.event
      let oX = x.clientX - iX
      let oY = x.clientY - iY
      $(`#${movdiv.attr('id')}`).css({
        'left': `${oX}px`,
        'top': `${oY}px`
      })
      return false
    }
  })

  $('#printmap').on('mouseup', function (e) {
    dragging = false
    e.cancelBubble = true
  })
}

const setModalSize = () => {
  let maxHeight = window.innerHeight - 175
  let maxWidth = window.innerWidth - 100
  let mapWidth = $('#plwrapper').width() + 70
  $('#printMod .modal-body').css('max-height', `${maxHeight}px`)
  $('#printMod .modal-lg').css('width', `${mapWidth}px`)
  $('#printMod .modal-lg').css('max-width', `${maxWidth}px`)
}


/**
 * Update WTMS base layers theme
 * @param {The layer o update (cache or overview)} layer
 * @param {The zoomstack theme selected} theme
 */
const updatePrintLayer = (theme) => {
  if (pageconfig.print == false) {
    return
  }
  /**
   * Cache Layer
   */

  let capXml = functions.getCacheCapabilities()
  let newmmLayer = twmap.getMMLayer(theme)
  let newovLayer = theme
  if (tenant == 'iom') {
    layerClass = twmap.getIomLayerCSS(theme)
    newovLayer = 'mastermap:mm-IoM_Overview'
    capXml = functions.getMMCacheCapabilities()
    newmmLayer = 'mastermap:mm-IoM'
  }
 
  var parser = new WMTSCapabilities()
  var result = parser.read(capXml)

  var options = optionsFromCapabilities(result, {
    layer: newovLayer,
    matrixSet: 'BC27700',
    format: 'image/png8',
  })

  var source = new WMTS(options)
  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]
  let minZoom = pageconfig.minzoom
  let cachelayer = new TileLayer({className: layerClass,extent: ext, source: source,minResolution: resolutions[minZoom]})
  printmap.getLayers().array_[0] = cachelayer
  /**
   * End Cache Layer
   */

  /**
   * Mastermap Layer
   */
  let mmcapXml = functions.getMMCacheCapabilities()
  var parser = new WMTSCapabilities()
  var mmresult = parser.read(mmcapXml)
  var mmoptions = optionsFromCapabilities(mmresult, {
    layer: newmmLayer,
    matrixSet: 'BC27700'
  })

  var mmsource = new WMTS(mmoptions)

  let maplayer = new TileLayer({className: layerClass, id: 'maplayer', extent: ext, source: mmsource, resolutions: resolutions, maxResolution: resolutions[minZoom-1], preload: Infinity})
  printmap.getLayers().array_[1] = maplayer
  /**
   * End Mastermap Layer
   */
}
/**
 * EXPORT
 */

export default {
  initPrint,
  setModalSize,
  updatePrintLayer
}
